import { EnumOptions } from "@/types";

export function renderEnumDescription<T>(value: T, options: EnumOptions<T>): string | undefined {
  return options.enumValues.find((opt) => opt.name === value)?.description;
}
